// src/pages/Home/Homepage.jsx
import React, { useState } from "react";
import { Row, Col, Spin, Pagination, Input, Select, Card } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import BlogLayout from "../../components/BlogLayout";
import BlogPostList from "../../components/BlogPostList";
import BlackParticleBackground from "../../components/BlackParticleBackground";
import Sidebar from "../../components/Sidebar";
import {
  usePosts,
  useCategories,
  useTags,
  usePopularPosts,
  useAuth,
} from "../../hooks/useBlogAPI";

const { Option } = Select;

const HomePage = () => {
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [selectedTag, setSelectedTag] = useState(undefined);

  const navigate = useNavigate();
  const { user } = useAuth();

  const filters = {
    search: searchTerm,
    categoryId: selectedCategory,
    tag: selectedTag,
  };

  const { data: posts, loading, pagination } = usePosts(page, 5, filters);
  const { data: categories } = useCategories();
  const { data: tags } = useTags();
  const { data: popularPosts } = usePopularPosts();

  const handleReadMore = (postId) => {
    navigate(`/posts/${postId}`);
  };

  const handleCreatePost = () => {
    navigate("/posts/create");
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setPage(1);
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    setPage(1);
  };

  const handleTagChange = (value) => {
    setSelectedTag(value);
    setPage(1);
  };

  return (
    <>
      <BlackParticleBackground />
      <BlogLayout onCreatePost={handleCreatePost}>
        <div className="container">
          <Card
            className="filter-bar"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              borderRadius: 8,
              marginBottom: 24,
            }}
          >
            <Row gutter={16} align="middle">
              <Col xs={24} sm={12} md={8}>
                <Input
                  placeholder="搜索文章..."
                  prefix={<SearchOutlined />}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                  onBlur={(e) => handleSearch(e.target.value)}
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    borderColor: "#d9d9d9",
                  }}
                />
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Select
                  placeholder="选择分类"
                  allowClear
                  style={{ width: "100%" }}
                  onChange={handleCategoryChange}
                  dropdownStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                  }}
                >
                  {categories.map((category) => (
                    <Option key={category.id} value={category.id}>
                      {category.name} ({category.postCount})
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <div style={{ display: "flex", gap: 8 }}>
                  <Select
                    placeholder="选择标签"
                    allowClear
                    mode="multiple"
                    style={{ flex: 1 }}
                    onChange={handleTagChange}
                    dropdownStyle={{
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                    }}
                  >
                    {tags.map((tag) => (
                      <Option key={tag.id} value={tag.name}>
                        {tag.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
            </Row>
          </Card>

          <Row gutter={24}>
            <Col
              xs={24}
              md={16}
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                borderRadius: 8,
                padding: "20px",
              }}
            >
              <Spin spinning={loading}>
                <BlogPostList
                  posts={posts}
                  loading={loading}
                  onReadMore={handleReadMore}
                />

                {!loading && pagination.totalPages > 1 && (
                  <div className="pagination-wrapper">
                    <Pagination
                      current={pagination.current}
                      pageSize={pagination.pageSize}
                      total={pagination.total}
                      onChange={setPage}
                      showSizeChanger={false}
                    />
                  </div>
                )}
              </Spin>
            </Col>

            <Col xs={24} md={8}>
              <div
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  borderRadius: 8,
                  padding: "20px",
                }}
              >
                <Sidebar popularTags={tags} popularPosts={popularPosts} />
              </div>
            </Col>
          </Row>
        </div>
      </BlogLayout>
    </>
  );
};

export default HomePage;
